import React from 'react';
import ConfiguratorTemplate from './ConfiguratorTemplate';

const HiddenTemplate = () => (<></>);

export default ConfiguratorTemplate(HiddenTemplate);
